import '../styles/component-styles.css'

function LoadFooter() {
    return (
        <footer>
            <p>© 2024 HyperWorks Imaging. All Rights Reserved. | Proprietary and Confidential.</p>
            <a href="/privacy-policy">Privacy Policy</a>
        </footer>
    )
}

export default LoadFooter;